// Updates a specific field in an array within the form data
export const updateFormItem = (
  setFormData: React.Dispatch<React.SetStateAction<any>>,
  key: string,
  index: number,
  field: string,
  value: any
) => {
  setFormData((prev: any) => {
    const updatedArray = [...prev[key]];
    updatedArray[index] = { ...updatedArray[index], [field]: value };
    return { ...prev, [key]: updatedArray };
  });
};

// Removes an item from an array within the form data
export const removeFormItem = (
  setFormData: React.Dispatch<React.SetStateAction<any>>,
  key: string,
  index: number
) => {
  setFormData((prev: any) => {
    const updatedArray = [...prev[key]];
    updatedArray.splice(index, 1);
    return { ...prev, [key]: updatedArray };
  });
};

// Adds a new item to an array within the form data
export const addFormItem = (
  setFormData: React.Dispatch<React.SetStateAction<any>>,
  key: string,
  newItem: any
) => {
  setFormData((prev: any) => ({
    ...prev,
    [key]: [...prev[key], newItem],
  }));
};
